import { render } from "./TarjetaModalComponent.vue?vue&type=template&id=3f8ace48&scoped=true"
import script from "./TarjetaModalComponent.vue?vue&type=script&lang=js"
export * from "./TarjetaModalComponent.vue?vue&type=script&lang=js"

import "./TarjetaModalComponent.vue?vue&type=style&index=0&id=3f8ace48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8ace48"]])

export default __exports__